var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.107 20.667C19.98 20.667 21.499 19.149 21.5 17.276V17.274V14.574C20.263 14.574 19.261 13.572 19.26 12.335C19.26 11.099 20.262 10.096 21.499 10.096H21.5V7.396C21.502 5.522 19.985 4.002 18.112 4H18.106H6.394C4.52 4 3.001 5.518 3 7.392V7.393V10.183C4.194 10.141 5.195 11.075 5.237 12.269C5.238 12.291 5.239 12.313 5.239 12.335C5.24 13.57 4.241 14.572 3.006 14.574H3V17.274C2.999 19.147 4.518 20.667 6.391 20.667H6.392H18.107Z",
    stroke: "#5C5C64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6211 9.31303L13.2371 10.56C13.2971 10.682 13.4131 10.767 13.5481 10.787L14.9251 10.988C15.2661 11.038 15.4011 11.456 15.1551 11.695L14.1591 12.665C14.0611 12.76 14.0171 12.897 14.0391 13.032L14.2741 14.402C14.3321 14.741 13.9771 14.999 13.6731 14.839L12.4421 14.192C12.3211 14.128 12.1771 14.128 12.0561 14.192L10.8261 14.839C10.5211 14.999 10.1661 14.741 10.2241 14.402L10.4591 13.032C10.4821 12.897 10.4371 12.76 10.3391 12.665L9.34409 11.695C9.09809 11.456 9.23309 11.038 9.57309 10.988L10.9501 10.787C11.0851 10.767 11.2021 10.682 11.2621 10.56L11.8771 9.31303C12.0291 9.00503 12.4691 9.00503 12.6211 9.31303Z",
    stroke: "#5C5C64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.ee4e1f861ae3df4317302832026a82bf.svg";
export { ForwardRef as ReactComponent };